var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"overlay"}},[_c('v-progress-circular',{key:_vm.theme.color,staticClass:"loading",attrs:{"size":"80","width":4,"indeterminate":"","color":_vm.theme.color}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }